import React from "react";
import { FiUsers, FiUserCheck, FiUserX, FiClock, FiGift, FiCalendar, FiClipboard } from "react-icons/fi";

export default function ManagerDashboard() {
  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl font-semibold">Manager Dashboard</h2>

      {/* Top Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">

        {/* Team Strength */}
        <div className="bg-white shadow rounded-xl p-5 flex items-center gap-4">
          <FiUsers size={35} className="text-purple-600" />
          <div>
            <p className="text-gray-500 text-sm">Team Strength</p>
            <h3 className="text-xl font-bold">12 Members</h3>
          </div>
        </div>

        {/* Present Today */}
        <div className="bg-white shadow rounded-xl p-5 flex items-center gap-4">
          <FiUserCheck size={35} className="text-green-600" />
          <div>
            <p className="text-gray-500 text-sm">Present Today</p>
            <h3 className="text-xl font-bold">9 Employees</h3>
          </div>
        </div>

        {/* Absent Today */}
        <div className="bg-white shadow rounded-xl p-5 flex items-center gap-4">
          <FiUserX size={35} className="text-red-600" />
          <div>
            <p className="text-gray-500 text-sm">Absent Today</p>
            <h3 className="text-xl font-bold">2 Employees</h3>
          </div>
        </div>

        {/* Late Check-ins */}
        <div className="bg-white shadow rounded-xl p-5 flex items-center gap-4">
          <FiClock size={35} className="text-orange-500" />
          <div>
            <p className="text-gray-500 text-sm">Late Check-ins</p>
            <h3 className="text-xl font-bold">1 Employee</h3>
          </div>
        </div>
      </div>

      {/* Two Column Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* Pending Approvals */}
        <div className="bg-white shadow rounded-xl p-5 col-span-2">
          <h3 className="text-lg font-semibold mb-4">Pending Approvals</h3>

          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-100 border-b">
                <th className="p-3 text-left">Employee</th>
                <th className="p-3 text-left">Request</th>
                <th className="p-3 text-left">Date</th>
                <th className="p-3 text-left">Action</th>
              </tr>
            </thead>

            <tbody>
              <tr className="border-b">
                <td className="p-3">Rahul Kumar</td>
                <td className="p-3">Leave Request</td>
                <td className="p-3">12 Jan 2025</td>
                <td className="p-3 text-blue-600 cursor-pointer">Review</td>
              </tr>
              <tr className="border-b">
                <td className="p-3">Priya Sharma</td>
                <td className="p-3">Timesheet Approval</td>
                <td className="p-3">11 Jan 2025</td>
                <td className="p-3 text-blue-600 cursor-pointer">Review</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Team Birthdays */}
        <div className="bg-white shadow rounded-xl p-5">
          <h3 className="text-lg font-semibold mb-4">Team Birthdays</h3>

          <ul className="space-y-3 text-sm">
            <li className="p-3 bg-purple-50 rounded border">
              🎉 Amit Kumar – Jan 15
            </li>
            <li className="p-3 bg-purple-50 rounded border">
              🎉 Neha Singh – Jan 22
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        {/* Upcoming Leaves */}
        <div className="bg-white shadow rounded-xl p-5">
          <h3 className="text-lg font-semibold mb-4">Upcoming Leaves</h3>

          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-100 border-b">
                <th className="p-3 text-left">Employee</th>
                <th className="p-3 text-left">Date</th>
                <th className="p-3 text-left">Type</th>
              </tr>
            </thead>

            <tbody>
              <tr className="border-b">
                <td className="p-3">Ravi Singh</td>
                <td className="p-3">18 Jan 2025</td>
                <td className="p-3">Sick Leave</td>
              </tr>
              <tr className="border-b">
                <td className="p-3">Sneha Patel</td>
                <td className="p-3">20 Jan 2025</td>
                <td className="p-3">Casual Leave</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Recent Check-ins */}
        <div className="bg-white shadow rounded-xl p-5">
          <h3 className="text-lg font-semibold mb-4">Recent Check-ins</h3>

          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-100 border-b">
                <th className="p-3 text-left">Employee</th>
                <th className="p-3 text-left">Check-in</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>

            <tbody>
              <tr className="border-b">
                <td className="p-3">Vikram Josh</td>
                <td className="p-3">09:05 AM</td>
                <td className="p-3 text-green-600">Present</td>
              </tr>
              <tr className="border-b">
                <td className="p-3">Meera Rao</td>
                <td className="p-3">-</td>
                <td className="p-3 text-red-600">Absent</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}
